const NAMESPACE = 'PLACE_GUIDE';

const SET_PLACE_GUIDE_CONTENT = `${NAMESPACE}/SET_PLACE_GUIDE_CONTENT`;

export {
    SET_PLACE_GUIDE_CONTENT,
};

export default NAMESPACE;
